import React from 'react';

import {MainLayout} from 'widgets/layout';

import {PortMonitorDetails} from 'features/port';

const PortMonitorDetailsPage: React.FC = () => {
    return (
        <MainLayout>
            <PortMonitorDetails />
        </MainLayout>
    );
};

export default PortMonitorDetailsPage;
